import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import ProjectsPage from './pages/ProjectsPage'
import EditorPage from './pages/EditorPage'
import PlayPage from './pages/PlayPage'
import AdminPage from './pages/AdminPage'
import ErrorPage from './pages/ErrorPage'
import './App.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/editor" element={<EditorPage />} />
        <Route path="/play" element={<PlayPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
)
